import { EventIdentifier, FeatureTeamEvent, TrackingEventType, useAnalytics } from '@capsicum/common';
import { useNCWBalance } from '@capsicum/socios-core';
import { useEffect, useState } from 'react';

export const useNCOnboarding = () => {
	const analytics = useAnalytics();
	const [activeSlide, setActiveSlide] = useState(0);
	const { chilizBalance, isPending: isLoading, tokenBalances } = useNCWBalance();

	useEffect(() => {
		if (isLoading || !chilizBalance) return;

		analytics.sendEvent(TrackingEventType.track, EventIdentifier.PageView, {
			chz_amount: chilizBalance.amount,
			feature_team: FeatureTeamEvent.ORFT,
			ft_amount: tokenBalances.reduce((acc, balance) => acc + balance.amount, 0),
			text: `nconboarding_slide_${activeSlide}`
		});
	}, [analytics, activeSlide, isLoading, chilizBalance, tokenBalances]);

	return {
		isLoading,
		onActiveSlideChange: setActiveSlide
	};
};
